<div [ngStyle]="timelineWrapperStyle()">
  @for (level of state.levels; track level; let levelIndex = $index) {
    <div class="status-timeline-level-wrapper">
      <div class="lines-wrapper">
        @if (!isCurrentStateFinal() && isLastLevel(levelIndex)) {
          <div
          [ngStyle]="predictionLineStyle(levelIndex)" class="prediction-line"></div>
        }
        <div [ngStyle]="historyLineStyle(levelIndex)" class="history-line">
          @if (levelIndex !== state.levels.length - 1) {
            <div class="diagonal-wrapper">
              <div [ngStyle]="diagonalLineStyle(levelIndex)"
              class="history-line diagonal-line"></div>
            </div>
          }
        </div>
      </div>
      <div [ngStyle]="retrieveGridTemplateForLevel(level)" class="status-timeline-level-grid">
        @for (entry of level; track entry; let index = $index) {
          <div #historyLineEntry
            class="status-timeline-entry-wrapper">
            @if (showCollapseArrow(entry)) {
              <div (click)="toggleCollapse()"
                [attr.class]="collapseArrowClass()"
                [attr.data-cy]="collapsibleButtonCypressTag"
                [ngStyle]="backgroundStyle()">
                @if (state.isCollapsed) {
                  <div class="state-collapse-arrow-ellipsis"
                  data-cy="state-collapse-arrow-ellipsis">...</div>
                }
              </div>
            }
            <div [attr.class]="entryClass(entry)">
              @if (entry.state?.name != null) {
                @if (entry.state.flag != null) {
                  <div class="state-flag"
                  [attr.data-cy]="stateFlagCypressTag(levelIndex, index)">{{entry.state.flag}}</div>
                }
                <div class="state-dot-wrapper">
                  <span [attr.class]="entryDotClass(entry.state)"
                    [ngStyle]="entryDotStyle(entry)"
                    [attr.data-cy]="stateDotCypressTag(levelIndex, index)"
                  ></span>
                </div>
                <div [attr.class]="labelClass('state-name-label', level, levelIndex, entry)"
                  [innerHTML]="getLabelName(entry)"
                [attr.data-cy]="stateNameCypressTag(levelIndex, index)"></div>
                <span [attr.class]="labelClass('state-date-label', level, levelIndex, entry)"
                  [attr.data-cy]="stateDateCypressTag(levelIndex, index)"
                >{{entry.timestamp | date: 'dd-MM-yyyy'}}</span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
